var map = {
	"./ADMINISTRATIVE.svg": "9f1f",
	"./CHECKLIST.svg": "c629",
	"./CLIENT.svg": "ca1f",
	"./COMMUNICATION.svg": "388d",
	"./DOCUMENTATION.svg": "49c0",
	"./FUNDAMENTAL.svg": "43e8",
	"./HR.svg": "7765",
	"./INNOVATION.svg": "12dc",
	"./IS.svg": "cb12",
	"./LEAN.svg": "a93a",
	"./LOG.svg": "ae73",
	"./PILOTAGE.svg": "fd16",
	"./PROCESS.svg": "3c1c",
	"./PRODUCTION.svg": "7275",
	"./QUALITY.svg": "db0d",
	"./REPORTING.svg": "903e",
	"./SALES.svg": "9080",
	"./STRATEGY.svg": "3173"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf88";